<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('product.editProductCard') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="product-card-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div v-if="cardData.local_file" class="form-group">
            <label>
              {{ $t('product.currentFile') }}:
            </label>
            <div>
              {{ cardData.local_file }}
            </div>
          </div>

          <div class="form-group">
            <label>
              {{ $t('ui.file') }} (PDF):
            </label>

            <file-input
              :onChange="setNewFile"
              id="productCardEditInputFile" />
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'product-card-edit-popup',
  props: {
    productID: {
      default: 0,
      type: Number
    },
    cardData: {
      default: () => ({}),
      type: Object
    },
    languages: {
      default: () => ([]),
      type: Array
    },
    usedLanguageIDs: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages
        .filter(language => language.id > 1 && (language.id === this.cardData.language_id || this.usedLanguageIDs.indexOf(language.id) === -1))
        .map(language => ({
          value: language.id,
          text: language.name
        }));
    }
  },
  data () {
    return {
      cardID: this.cardData.id,
      language: this.cardData.language_id,
      file: null,
      saveInProgress: false
    };
  },
  methods: {
    handleClose (cardID) {
      this.$bus.$emit('product-card-edit-popup-close', cardID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['product-card-edit-form'], this.saveCard);
    },
    setNewFile (event) {
      this.file = event.target.files[0];
    },
    saveCard () {
      this.saveInProgress = true;

      let formData = {
        product_id: this.productID,
        language_id: this.language
      };
      let imageFields = false;

      if (this.file) {
        formData.file = this.file;
        imageFields = ['file'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/products/datasheets/update/' + this.cardID,
        formData,
        successTitle: this.$t('product.editProductCardSuccessTitle'),
        successText: this.$t('product.editProductCardSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('product.editProductCardErrorText'),
        successAction: res => {
          this.saveInProgress = false;
          this.$bus.$emit('product-reload-cards');
          this.handleClose(res.id);
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      }, imageFields);
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
